





















import TitleSection from '@spa/components/atoms/TitleSection.vue'
import { PluginMixin } from '@spa/mixins/plugin'
import { CallbackErrorMessageParse, ThreeDSecureResultPageMixin } from '@spa/mixins/three-d-secure-result-page'
import _ from 'lodash'

import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

Component.registerHooks([
  'beforeRouteEnter',
])

type MixedIn = PluginMixin
  & ThreeDSecureResultPageMixin

@Component({
  components: {
    TitleSection,
  },
  mixins: [
    ThreeDSecureResultPageMixin,
  ],
})
/**
 * カード登録で3D認証のリダイレクト先がそもそも正常に取得できなかった場合に表示するフォールバック的なエラーページ。
 * リダイレクト先が正しい取得できている通常のケースでは、リダイレクト先ページで結果を受け取ってエラーを表示するため、このページを使うことはない。
 */
export default class UnexpectedCreditcardRegsiterError extends
  Mixins<MixedIn>(
    PluginMixin,
    ThreeDSecureResultPageMixin
  ) {

  get errorMessage(): string {
    return new CallbackErrorMessageParse().parse(
      this.threeDSecureCallbackErrorType,
      this.threeDSecureCallbackErrorCode,
      this.threeDSecureCallbackErrorCredit,
      this.threeDSecureCallbackErrorMessage
    ) || ''
  }
}
